<script lang="ts">
import { getLinkAttributes, stripSiteDomain } from '$lib/utils/url.js';
import { ERoutes } from '../../../config/enums';

let { text = '', serviceItems = [], industriesItems = [], clientUrl = '' } = $props();

const transformedClientUrl = $derived(stripSiteDomain(clientUrl));
const clientUrlAttributes = $derived(getLinkAttributes(transformedClientUrl));
</script>

<div class="work-overview">
    <div class="work-overview__wrapper">
        {#if text}
            <div class="work-overview__intro">
                {text}
            </div>
        {/if}

        <div class="work-overview__sections">
            {#if serviceItems.length > 0}
                <div class="work-overview__section">
                    <h3 class="work-overview__section-title">Services</h3>
                    <ul class="work-overview__section-list">
                        {#each serviceItems as item (item.service?.id)}
                            <li class="work-overview__list-item">
                                <a
                                    href="{ERoutes.Work}?services={encodeURIComponent(
                                        item.service?.value?.name.toLowerCase()
                                    )}">{item.service?.value?.name}</a
                                >
                            </li>
                        {/each}
                    </ul>
                </div>
            {/if}

            {#if industriesItems.length > 0}
                <div class="work-overview__section">
                    <h3 class="work-overview__section-title">Industries</h3>
                    <ul class="work-overview__section-list">
                        {#each industriesItems as item (item.industry?.id)}
                            <li class="work-overview__list-item">
                                <a
                                    href="{ERoutes.Work}?industry={encodeURIComponent(
                                        item.industry?.value?.name.toLowerCase()
                                    )}">{item.industry?.value?.name}</a
                                >
                            </li>
                        {/each}
                    </ul>
                </div>
            {/if}

            {#if transformedClientUrl}
                <div class="work-overview__section">
                    <h3 class="work-overview__section-title">Website</h3>
                    <a href={transformedClientUrl} {...clientUrlAttributes}>{clientUrl}</a>
                </div>
            {/if}
        </div>
    </div>
</div>

<style lang="scss">
    @use '/src/scss/global-constants/fonts';
    @use '/src/scss/global-constants/mq-config';
    @use 'sass-mq/mq' as *;

    .work-overview {
        padding: 5rem var(--layout-pagegrid-margin);

        @include mq($from: tablet) {
            display: grid;
            column-gap: var(--layout-pagegrid-gutter);
            grid-template-columns: [first] repeat(var(--layout-pagegrid-col-count), 1fr) [end];
        }

        &__wrapper {
            grid-column: 2 / -2;
        }

        &__intro {
            font-size: 1.9rem;
            font-weight: fonts.$fonts-weight--normal;
            line-height: 1.4;
            margin-bottom: 3rem;

            @include mq($from: tablet) {
                font-size: 3.2rem;
                letter-spacing: -0.096rem;
                margin-bottom: 8rem;
                max-width: 50ch;
            }
        }

        &__sections {
            align-items: center;
            align-items: flex-start;
            display: flex;
            flex-wrap: wrap;
            gap: 3rem;
            justify-content: space-between;

            @include mq($from: tablet) {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
            }
        }

        &__section {
            a {
                color: currentColor;
                text-decoration: none;
                text-underline-offset: 0.6rem;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        &__section-title {
            font-weight: fonts.$fonts-weight--medium;
            font-size: 1.6rem;
            margin-bottom: 1.6rem;

            @include mq($from: tablet) {
                font-size: 2.2rem;
                font-weight: fonts.$fonts-weight--normal;
                margin-bottom: 3rem;
            }
        }

        &__section-list {
            margin: 0;
            padding: 0;
            font-weight: fonts.$fonts-weight--normal;
            font-size: 1.6rem;
            line-height: 1.6;

            // two columns if we have more than 6 items
            &:has(:global(> :nth-child(7))) {
                @include mq($from: tablet) {
                    column-count: 2;
                }
            }
        }

        &__list-item {
            list-style: inside disc;

            @include mq($from: tablet) {
                white-space: nowrap;
            }
        }
    }
</style>
